import React from "react";
import { isBooleanTrue, isStringNotEmpty } from "../../utils/objectUtils";
import { Button } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const Fieldset = ({ legend, isCollapsable = false, isCollapsed = false, className = "legend", children }) => {
    const [isRowCollapsed, setIsRowCollapsed] = React.useState(false);

    React.useEffect(() => {
        setIsRowCollapsed(isCollapsed);
    }, [isCollapsed]);

    const onCollapse = () => {
        setIsRowCollapsed(!isRowCollapsed);
    };

    const getCollapseIcon = () => {
        if (isBooleanTrue(isCollapsable)) {
            if (isBooleanTrue(isRowCollapsed)) {
                return (
                    <Button variant="link" onClick={onCollapse} style={{ marginLeft: 8 }}><FaChevronRight /></Button>
                );
            } else {
                return (
                    <Button variant="link" onClick={onCollapse} style={{ marginLeft: 8 }}><FaChevronDown /></Button>
                );
            }
        } else {
            return undefined;
        }
    };

    if (isBooleanTrue(isCollapsable)) {
        return (
            <fieldset>
                {isStringNotEmpty(legend) ? (<legend className={className}>{legend}{getCollapseIcon()}</legend>) : null}
                <div style={{ display: isRowCollapsed ? 'none' : 'inherit' }}>
                    {children}
                </div>
            </fieldset>
        );
    } else {
        return (
            <fieldset>
                {isStringNotEmpty(legend) ? (<legend className={className}>{legend}</legend>) : null}
                {children}
            </fieldset>
        );
    }
};

export default Fieldset;